import React, { Fragment } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal/Modal';
import Detail from '../../../components/Detail/Detail';
import styles from './assets/styles.scss';
import { games } from '../../../games/config';
import { assetIcons } from '../../../config';

import IconLink from './assets/link.svg?inline';

const cx = classNames.bind(styles);

export default function BetDetails({
  isOpen,
  onClose,
  isWin,
  status,
  betAmount,
  payout,
  payoutRate,
  gameCode,
  txId,
  payoutTxId,
  playerPick,
  result,
  asset,
  txIdForUrl,
}) {
  let statusText;
  let statusClassName;
  let winLossText;
  let winLossClassName;

  if (!result && !['slots', 'table', 'casual'].includes(gameCode)) {
    winLossText = '-';
  } else if (isWin || payout) {
    winLossClassName = 'win';
    winLossText = payout;
  } else {
    winLossClassName = 'loss';
    winLossText = -betAmount;
  }
  if (status === 'fail') {
    statusClassName = 'red';
    statusText = 'Failed Bet';
    winLossClassName = null;
  } else if (['pending', 'waiting'].includes(status)) {
    statusClassName = 'yellow';
    statusText = 'Pending Bet';
    winLossClassName = null;
  }

  return (
    <Fragment>
      <span className={cx('bet-details-button', 'bold', 'small', statusClassName || winLossClassName)}>
        {statusText || winLossText}
        {result && <IconLink />}
      </span>
      <Modal
        header="Bet Details"
        dark
        isOpen={isOpen}
        onClose={onClose}
        className={cx('bet-details-modal')}
        backgroundColor="#1F0D53"
      >
        <img src={games[gameCode].thumbnail} alt={gameCode} />
        <div className={cx('pick-result')}>
          <Detail label="My Pick:" content={playerPick} contentClassName="small" inline />
          <Detail label="Result:" content={result || '-'} contentClassName="small" inline />
        </div>
        <Detail
          label="Bet"
          className={cx('bet')}
          content={(
            <span className={cx('small', 'text-icon')}>
              {betAmount}
              {assetIcons[asset]({})}
            </span>
          )}
        />
        <Detail label="Multiplier" content={payoutRate} contentClassName="small" />
        <Detail
          label="Payout"
          className={cx('payout')}
          content={(
            <span className={cx('small', 'bold', 'text-icon', winLossClassName)}>
              {winLossText}
              {assetIcons.BSV({})}
            </span>
          )}
        />
        <Detail
          label="Bet TxID"
          className={cx('full-width')}
          contentClassName={cx('xsmall', statusClassName)}
          content={statusText || txId}
          copiable={!statusText}
          href={`https://whatsonchain.com/tx/${txIdForUrl}`}
        />
        {status !== 'fail' && (
          <Detail
            label="Payout TxID"
            className={cx('full-width')}
            content={payoutTxId || '-'}
            contentClassName={cx('xsmall')}
            copiable={!!payoutTxId}
            href={payoutTxId && `https://whatsonchain.com/tx/${payoutTxId}`}
          />
        )}
      </Modal>
    </Fragment>
  );
}
BetDetails.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isWin: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  betAmount: PropTypes.number.isRequired,
  payout: PropTypes.number,
  payoutRate: PropTypes.string.isRequired,
  gameCode: PropTypes.string.isRequired,
  playerPick: PropTypes.string.isRequired,
  result: PropTypes.string.isRequired,
  txId: PropTypes.string.isRequired,
  payoutTxId: PropTypes.string,
  asset: PropTypes.string.isRequired,
  txIdForUrl: PropTypes.string.isRequired,
};
BetDetails.defaultProps = {
  payout: null,
  payoutTxId: null,
};
